<template>
  <div v-if="showComponent">
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <div v-html="html" />
  </div>
</template>

<script>
// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    html: {
      type: String,
      default: ''
    },
    showEditButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>
